import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { KPI_CROSS_SELL_UP_SELL } from '../../kpis';

/** Representa o Filter da entidade TipoClassificacao */
export class TipoClassificacaoFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    cadastros: number[] = [];
    situacao: number;
    crossSells: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Cadastros
        this.cadastros?.forEach(cadastro => params = params.append('cadastro', cadastro.toString()));

        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }

        // Cross Sells
        this.crossSells?.forEach(crossSell => params = params.append('crossSell', crossSell.toString()));

        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.cadastros = [];
        this.situacao = null;
        this.crossSells = [];
    }
}

